export default __webpack_public_path__ + "static/media/Portrait_Placeholder.157f088b.png";